/* eslint-disable no-shadow */
import React, { Component } from 'react';
import { Dispatch as Dispatch_ } from 'redux';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps as RouteComponentProps_ } from 'react-router-dom';
import hashParse from 'hash-parse';
import userManager from '../../utils/userManager';
import RedirectPage from './redirect';
import BaseApi, { PROMPT } from '../../data/base-api';
import CallbackComponent from './callback-component';
import { AppState as AppState_ } from '../../redux/app-state';
import putWebUserStatusRefresh from '../../redux/actions/web-user-status-actions';
import { sessionStorageVariables } from '../../utils/enum';
import { AppDispatch } from '../../data/models/AppDispatch';

type TokenCallbackProps = {
    dispatch: Dispatch_<any>,
    putWebUserStatusRefresh: (params: string) => void
} & RouteComponentProps_

export class TokenCallback extends Component<TokenCallbackProps> {
  constructor(props) {
    super(props);
    this.successCallback.bind(this);
    this.errorCallback.bind(this);
  }

    successCallback = user => {
      // eslint-disable-next-line no-underscore-dangle
      const store = userManager.settings.userStore._store;
      const { history, putWebUserStatusRefresh, } = this.props;

      const { profile, } = user;
      // Prevent cross FI logins
      // Using user session from logged user for different FI Online portal
      // Independent institution sources:
      // window.institutionId set from CDN
      // user.InstituitionId set from IDP
      if ((profile || {}).InstitutionId !== window.institutionId) {
        BaseApi.signinRedirect({ prompt: PROMPT.LOGIN, });
        return;
      }
      store.setItem('access_token', user.access_token);
      sessionStorage.setItem(sessionStorageVariables.userEmail, profile.email);

      const redirectBackTo = store.getItem('redirectLocalBackTo');
      putWebUserStatusRefresh('Refresh');

      history.push(redirectBackTo || '/home');
    };

    errorCallback = (error) => {
      const { location, } = this.props;
      const hash = hashParse.parse(location.hash);

      if (hash.error === 'login_required') {
        BaseApi.signinRedirect({ prompt: PROMPT.LOGIN, });
      }
      console.log(error);

      // LV-20463: Known issue at oidc library - OidcClient.processSigninResponse
      // As work around, prompt user to login
      if (error?.message?.includes('No matching state found in storage')) {
        BaseApi.signinRedirect({ prompt: PROMPT.LOGIN, });
      }
    };

    render() {
      return (
        <CallbackComponent successCallback={this.successCallback} errorCallback={this.errorCallback} userManager={userManager}>
          <RedirectPage />
        </CallbackComponent>
      );
    }
}

export default withRouter(connect(
  (state: AppState_) => ({ ...state, }),
  (dispatch: AppDispatch) => {
    return {
      putWebUserStatusRefresh: (params) => dispatch(putWebUserStatusRefresh(params)),
    };
  }
)(TokenCallback));
